<p-select
  [(ngModel)]="year"
  (onChange)="loadYear()"
  [options]="years"
  [style]="{ width: '100%', 'margin-bottom': '1rem' }"
  appScrollIntoView></p-select>

<div class="calendar">
  @for (month of calendar.months; track $index; let i = $index) {
    <div class="month">
      <h5>{{ 'PRIMENG.monthNames.' + i | translate }}</h5>
      <table>
        <tr>
          @for (day of month.weeks[0].days; track $index) {
            <th>{{ 'PRIMENG.dayNamesMin.' + day.getDay() | translate }}</th>
          }
        </tr>
        @for (week of month.weeks; track $index) {
          <tr>
            @for (day of week.days; track $index) {
              <td
                (click)="clickDay(day)"
                [class.changed]="isChanged(day)"
                [class.out]="day.getMonth() !== i"
                [class.selected]="isSelected(day)">
                {{ day.getDate() }}
              </td>
            }
          </tr>
        }
      </table>
    </div>
  }
</div>

<p-button
  (onClick)="save()"
  [disabled]="changed.length === 0"
  [label]="'ACTIONS.SAVE' | translate"
  [style]="{ 'margin-right': '0.5rem' }"
  icon="fal fa-save"></p-button>
<p-button
  (onClick)="cancel()"
  [label]="'ACTIONS.CANCEL' | translate"
  icon="fal fa-times"
  styleClass="p-button-secondary"></p-button>
